import { OnInit, Component, Input, EventEmitter, Output } from '@angular/core';
import { Wrapper } from '../wrapper.component';
import { BrandOption, BrandingData, BrandingSelectData } from 'globals/store/publish.data';
import { ManageBrandingComponent, ManageBrandingData } from './manage-branding.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { PublishInfo } from 'globals/store/share.data';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { CommonModule } from '@angular/common';
import { BrandingBlockWrapperComponent } from './branding-block.component';
import { BrandTemplateComponent } from './brand-template.component';
import { BrandImageComponent } from './brand-image.component';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { FooterLinksComponent } from './footer-links.component';

@Component({
    selector: 'publish-builder',
    templateUrl: "./publish-builder.html",
    styles: [`
  img.header, img.footer { cursor: pointer; margin: 0 auto; display: flex; }
  branding-block, branding-text, img.header, img.footer { margin-bottom: 40px; width: 1330px; max-width: 100%; }
  calls-to-action { margin: 20px auto 0; }
  performer-gallery { pointer-events: none; margin-bottom: -30px; }
  .sponsors-holder { display: flex; flex-wrap: wrap; justify-content: space-around; margin-top: 20px; }
  sponsor-gallery-card { margin: 0 20px 20px; }
  brand-template { margin-top: 40px; }
`],
    styleUrls: ['../publish-timeline/publish-timeline.scss'],
    standalone: true,
    imports: [CommonModule, BrandingBlockWrapperComponent, BrandTemplateComponent, BrandImageComponent, SocialLinksComponent, FooterLinksComponent]
})
export class PublishBuilderComponent extends Wrapper<PublishBuilderComponent> implements OnInit {
  @Input() home: boolean
  @Input() publishInfo: PublishInfo
  brandingData: BrandingData
  @Output() editCTAs: EventEmitter<void> = new EventEmitter()
  canEditAccount: boolean

  ngOnInit() {
    const brandingSelectData: BrandingSelectData = {
      type: 'publish',
      publishId: this.publishInfo.publishCode
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
    this.selectProp(clipboardEditingPrivilegesReselector, null, 'canEditAccount')
  }

  constructor() {
    super()
  }

  async editBranding(brandingOption: BrandOption) {
    console.log("Should be opening branding options dialogue and changing " + brandingOption)
    const data: ManageBrandingData = { selectedTab: brandingOption, type: 'publish', publishId: this.publishInfo.publishCode, onAccount: this.canEditAccount }
    await openDialogGetResult(this.dialog, ManageBrandingComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }
  

}